module.exports = __webpack_public_path__ + "img/hide-closed-tasks.38fde14e.svg";